import { FC, ReactNode } from 'react'
import { InfoCircleOutlined } from '@ant-design/icons'
import { Tooltip } from 'antd'
import classes from './index.module.css'
import { TooltipProps } from 'antd/es/tooltip'
import cn from 'classnames'
import TooltipWrapper from '@UI/New/TooltipWrapper/TooltipWrapper'

interface InfoCompProps
  extends Omit<
    TooltipProps,
    'title' | 'className' | 'overlayClassName' | 'children'
  > {
  text: string
  className?: string
  customIcon?: ReactNode
}

const InfoComp: FC<InfoCompProps> = ({
  text,
  className,
  customIcon,
  ...props
}) => {
  return (
    <div className={cn(classes.wrapper, className)}>
      <TooltipWrapper title={text} className={classes.tooltip} {...props}>
        {customIcon ? (
          customIcon
        ) : (
          <InfoCircleOutlined
            className={classes.icon}
            onPointerEnterCapture={undefined}
            onPointerLeaveCapture={undefined}
          />
        )}
      </TooltipWrapper>
    </div>
  )
}

export default InfoComp
